var map = {
	"./attach-file-icon.svg": 71839,
	"./backup-icon.svg": 59215,
	"./brush-icon.svg": 20979,
	"./check-icon.svg": 85624,
	"./close-icon.svg": 66191,
	"./comment-icon.svg": 86536,
	"./copy-icon.svg": 19398,
	"./download-icon.svg": 35857,
	"./emoji-icon.svg": 60580,
	"./eye-icon.svg": 94400,
	"./graphic-icon.svg": 30877,
	"./group-icon.svg": 69386,
	"./hamburger-icon.svg": 75928,
	"./info-icon.svg": 8156,
	"./instructions-icon.svg": 68946,
	"./link-icon.svg": 27791,
	"./metrics-icon.svg": 95721,
	"./notes-icon.svg": 43633,
	"./open-external-icon.svg": 61051,
	"./open-icon.svg": 38624,
	"./redo-icon.svg": 67871,
	"./repeat-icon.svg": 75497,
	"./settings-icon.svg": 94451,
	"./team-members-icon.svg": 7782,
	"./team-mutes-icon.svg": 22847,
	"./undo-icon.svg": 86,
	"./unread-message-icon.svg": 46513,
	"./upload-icon.svg": 13652,
	"./videoconf-icon.svg": 48827,
	"./zoom-minus-icon.svg": 61418,
	"./zoom-plus-icon.svg": 63300
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45753;